import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import MyTickets from "./pages/MyTickets";
import MyPasses from "./pages/MyPasses";
import MyAccountPage from "./pages/AccountPage";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./AuthContext";
import VendorPage from "./pages/VendorPage";
import EventPage from "./pages/EventPage";
import VendorLogin from "./pages/VendorLogin";
import VendorSignup from "./pages/VendorSignup";
import VendorDashboard from "./pages/VendorDashboard";
import CheckoutPage from "./components/CheckoutPage";
import TicketPage from "./pages/TicketPage";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import OrganizationDashboard from "./pages/OrganizationDashboard";
import VendorDashboardLayout from "./components/VendorDashboardLayout";
import OrganizationPage from "./pages/OrganizationPage";
import PrivateRoute from "./components/PrivateRoute";
import PaymentCompletion from "./pages/PaymentCompletion";
import DemoIndex from "./pages/demo/DemoIndex";
import DistrictDemo from "./pages/demo/DistrictDemo";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/tickets"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyTickets />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/passes"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyPasses />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyAccountPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor-login"
            element={<VendorLogin />}
          />
          <Route
            path="/vendor-signup"
            element={
              <Layout>
                <VendorSignup />
              </Layout>
            }
          />
          <Route
            path="/vendor-dashboard"
            element={
              <ProtectedRoute vendorOnly>
                <VendorDashboardLayout>
                  <OrganizationDashboard />
                </VendorDashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/vendor/:vendorId"
            element={
              <ProtectedRoute vendorOnly>
                <VendorDashboardLayout>
                  <VendorDashboard />
                </VendorDashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/checkout"
            element={
              <Layout>
                <CheckoutPage />
              </Layout>
            }
          />

          <Route
            path="/organization/:organizationId/vendor/:vendorId"
            element={
              <ProtectedRoute vendorOnly>
                <VendorDashboardLayout>
                  <VendorDashboard />
                </VendorDashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route path="/vendor-page/:id" element={<VendorPage />} />
          <Route path="/organization-page/:id" element={<OrganizationPage />} />
          <Route path="/event-page/:id" element={<EventPage />} />
          <Route path="/ticket/:ticketId" element={<TicketPage />} />

          <Route
            path="/reset-password"
            element={
              <Layout>
                <ResetPassword />
              </Layout>
            }
          />
          
          <Route
            path="/organization/:organizationId"
            element={
              <ProtectedRoute vendorOnly>
                <VendorDashboardLayout>
                  <OrganizationDashboard />
                </VendorDashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment-completion"
            element={<PaymentCompletion />}
          />

          {/* District demo showcase (config-driven, public, no real checkout) */}
          <Route path="/demo" element={<DemoIndex />} />
          <Route path="/demo/:districtSlug" element={<DistrictDemo />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
